import { Component } from '@angular/core';

import { SelectItem } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { Observable, map } from 'rxjs';

import { IPaperAuthorAffiliationDialogData } from 'editing-tool/src/app/shared/components/paper/steps/authors/affiliation-dialog/paper-author-affiliation-dialog-data';
import { FormAnimations } from 'sc-common';
import { ApiMemberAddressDetails } from 'sc-common/core/services/open-api/main-api-client';

@Component({
    templateUrl: './paper-author-affiliation-dialog.component.html',
    animations: [FormAnimations.AnimateDisplay],
    standalone: false
})
export class PaperAuthorAffiliationDialogComponent {

    public readonly affiliation$: Observable<ApiMemberAddressDetails>;

    public readonly countries$: Observable<SelectItem[]>;

    private readonly _dialogData: IPaperAuthorAffiliationDialogData;

    constructor(dialogConfig: DynamicDialogConfig) {

        this._dialogData = dialogConfig.data as IPaperAuthorAffiliationDialogData;
        this.affiliation$ = this._dialogData.affiliation$.pipe(
            map((affiliation) => affiliation ?? new ApiMemberAddressDetails()));
        this.countries$ = this._dialogData.countries$;
    }
}
